import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
// Lazy-load todo lo de abajo del fold para reducir el JS inicial (mejora TBT y FCP)
const MetricsTestimonialsSection = lazy(() => import('./components/MetricsTestimonialsSection').then(m => ({
  default: m.MetricsTestimonialsSection
})));
const ExtendedTestimonialsSection = lazy(() => import('./components/ExtendedTestimonialsSection').then(m => ({
  default: m.ExtendedTestimonialsSection
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const TransitionHookSection = lazy(() => import('./components/TransitionHookSection').then(m => ({
  default: m.TransitionHookSection
})));
const ProductIntroSection = lazy(() => import('./components/ProductIntroSection').then(m => ({
  default: m.ProductIntroSection
})));
const ModulesSection = lazy(() => import('./components/ModulesSection').then(m => ({
  default: m.ModulesSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const UrgencySection = lazy(() => import('./components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PriceSection = lazy(() => import('./components/PriceSection').then(m => ({
  default: m.PriceSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const ComparisonSection = lazy(() => import('./components/ComparisonSection').then(m => ({
  default: m.ComparisonSection
})));
const FinalCtaSection = lazy(() => import('./components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const META_PIXEL_ID = '929826529816985';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/p7p4yqWRrfCRP3w1tzS2RV/english_en_familia_optimized.webp';
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&family=Fraunces:opsz,wght@9..144,700&display=swap';
function injectResourceHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const hints: Array<{
    rel: string;
    href: string;
    crossOrigin?: string;
  }> = [{
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }, {
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com'
  }, {
    rel: 'dns-prefetch',
    href: 'https://connect.facebook.net'
  }, {
    rel: 'dns-prefetch',
    href: 'https://www.facebook.com'
  }];
  hints.forEach(h => {
    if (document.querySelector(`link[rel="${h.rel}"][href="${h.href}"]`)) return;
    const link = document.createElement('link');
    link.rel = h.rel;
    link.href = h.href;
    if (h.crossOrigin) link.crossOrigin = h.crossOrigin;
    head.appendChild(link);
  });
  // Preload hero image (LCP candidate)
  if (!document.querySelector(`link[rel="preload"][href="${HERO_IMG}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = HERO_IMG;
    // @ts-ignore
    preload.fetchPriority = 'high';
    head.appendChild(preload);
  }
  // Cargar Google Fonts de forma NO bloqueante:
  // truco media="print" + onload swap a "all" — el navegador no bloquea render.
  if (!document.querySelector(`link[data-fonts="ef"]`)) {
    const font = document.createElement('link');
    font.rel = 'stylesheet';
    font.href = FONTS_HREF;
    font.media = 'print';
    font.setAttribute('data-fonts', 'ef');
    font.onload = () => {
      font.media = 'all';
    };
    head.appendChild(font);
  }
}
function loadMetaPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  (function (f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e) as HTMLScriptElement;
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    injectResourceHints();
    const schedule = (cb: () => void) => {
      const w = window as any;
      if (w.requestIdleCallback) {
        w.requestIdleCallback(cb, {
          timeout: 4000
        });
      } else {
        setTimeout(cb, 2500);
      }
    };
    if (document.readyState === 'complete') {
      schedule(loadMetaPixel);
    } else {
      const onLoad = () => schedule(loadMetaPixel);
      window.addEventListener('load', onLoad, {
        once: true
      });
      return () => window.removeEventListener('load', onLoad);
    }
  }, []);
  return <div className="font-sans text-white bg-familia-bg min-h-screen selection:bg-familia-cyan selection:text-familia-bg" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      {/* HeroSection se renderiza inmediatamente (eager) para garantizar LCP rápido */}
      <HeroSection data-id="element-3" />

      {/* Todo lo de abajo del fold se carga lazy (mejora TBT y JS inicial) */}
      <Suspense fallback={<div style={{
      minHeight: '200px'
    }} aria-hidden data-id="element-5" />} data-id="element-4">
        <MetricsTestimonialsSection data-id="element-6" />
        <ExtendedTestimonialsSection isInitial={true} data-id="element-7" />
        <PainSection data-id="element-8" />
        <TransitionHookSection data-id="element-9" />
        <ProductIntroSection data-id="element-10" />
        <ModulesSection data-id="element-11" />
        <BonusesSection data-id="element-12" />
        <UrgencySection data-id="element-13" />
        <PriceSection data-id="element-14" />
        <ExtendedTestimonialsSection data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <FaqSection data-id="element-17" />
        <ComparisonSection data-id="element-18" />
        <FinalCtaSection data-id="element-19" />
        <FooterSection data-id="element-20" />
      </Suspense>
    </div>;
}